import { registerStimulusFeature } from "./stimulus-feature-loader";

registerStimulusFeature("markdown-editor", () =>
  import("./controllers/markdown_editor_controller")
);

registerStimulusFeature("intake-form-builder", () =>
  import("./controllers/intake_form_builder_controller")
);
